import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import Page from 'components/widgets/Route';
import ModelDesign from './container/ModelDesign';
import ModelSummary from './container/ModelSummary';
import ModelsList from './container/ModelsList';
import { fetchApiSpecTypes } from '../apidocs/actions';
import * as actions from './actions';

class ModelsRoute extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.fetchModelsData = this.fetchModelsData.bind(this);
		this.fetchModel = this.fetchModel.bind(this);
		this.designModel = this.designModel.bind(this);
		this.composeModel = this.composeModel.bind(this);
		this.editModel = this.editModel.bind(this);
		this.createModel = this.createModel.bind(this);
	}

	fetchModelsData() {
		this.props.actions.fetchModels();
		this.props.actions.fetchApiSpecTypes();
	}

	fetchModel({ match: { params } }) {
		if (params && params.id) {
			this.props.actions.fetchModel(decodeURIComponent(params.id));
		}
	}

	designModel ({ match: { params } }, mode) {
		this.props.actions.designModel({
			modelSource: params && params.id && decodeURIComponent(params.id),
			mode,
			queryState: false
		});
	}

	composeModel(props) {
		this.designModel(props, 'compose');
	}

	createModel(props) {
		this.designModel(props, 'create');
	}

	editModel(props) {
		this.designModel(props, 'edit');
	}

	render() {
		const { match: { path } } = this.props;
		return (
			<Page>
				<Page.Route
					exact
					onEnter={this.fetchModelsData}
					path={path}
					component={ModelsList}
				/>
				<Page.Route
					hasNav={false}
					onEnter={this.composeModel}
					path={`${path}/compose`}
					component={ModelDesign}
				/>
				<Page.Route
					hasNav={false}
					onEnter={this.createModel}
					path={`${path}/create`}
					component={ModelDesign}
				/>
				<Page.Route
					hasNav={false}
					onEnter={this.editModel}
					path={`${path}/:id/edit`}
					component={ModelDesign}
				/>
				<Page.Route
					onEnter={this.fetchModel}
					path={`${path}/:id`}
					breadcrumbs={({ match }) => [
						{ path, name: this.intl.formatMsg('Models') },
						{ path: `${path}/:id`, name: decodeURIComponent(match.params.id) }
					]}
					component={ModelSummary}
				/>
			</Page>
		);
	}
}

ModelsRoute.propTypes = {
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired
	}).isRequired
};

function mapDispatchToProps(dispatch) {
	return {
		actions: {
			...bindActionCreators(actions, dispatch),
			fetchApiSpecTypes: bindActionCreators(fetchApiSpecTypes, dispatch)
		}
	};
}

export default compose(
	connect(
		null,
		mapDispatchToProps
	),
	injectIntl,
)(ModelsRoute);
